import styled from "styled-components";

export const MaintenanceWrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const MaintenanceTop = styled.main`
  height: 100%;
  width: 100%;
  background-image: url(publisherLogo.png), url(/icons/logo-background.svg);
  background-position: 70px 50px, left top;
  background-repeat: no-repeat;
  background-size: auto, auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MaintenanceText = styled.div`
  background: #FFFFFF;
  border: 1px solid #B7B5B6;
  border-radius: 15px;
  box-sizing: border-box;
  width: 833px;
  max-width: calc(100% - 32px);
  min-height: 225px;
  padding: 36px 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

export const MaintenanceTextHeader = styled.h1`
  margin: 0;
  font: normal normal 600 30px/40px 'Open Sans', sans-serif;
  letter-spacing: 0px;
  color: #231F20;
`;

export const MaintenanceTextRegular = styled.p`
  margin: 0;
  font: normal normal normal 21px/30px 'Open Sans', sans-serif;
  letter-spacing: 0px;
  color: #5D5B5C;
  white-space: pre-line;
`;
